<template>
  <lateral-modal
    :title="$t('transactions_edit_diet_modal_header')"
    :containerClass="isDragging ? 'ModalBox--dim' : ''"
    :footerClass="reviewStatus ? 'ModalBox--footer w-100 d-flex flex-column' : ''"
    @close="closeModal"
  >
    <template
      slot="extraAction"
      class="ModalBox-header d-flex justify-content-between align-items-center position-absolute p-3"
    >
      <transactions-dropdown
        v-if="!isGettingTransaction"
        :transactionId.sync="transactionId"
        @confirmDelete="deleteTransaction"
      ></transactions-dropdown>
    </template>
    <template slot="content">
      <div v-if="!isGettingTransaction">
        <transaction-detail-status :transaction="transaction"></transaction-detail-status>
        <div class="transaction-card">
          <div
            class="transaction-details-header"
            :class="[{pending: transactionIsPending}, transactionCategory(transaction.defaultCategoryOffice) ]"
            :style="{'backgroundImage': transactionCategory(transaction.defaultCategoryOffice)}"
          >
            <div class="transaction-details-merchant-info">
              <div class="transaction-date-status">
                <span class="transaction-date">
                  {{ transactionDate | formatTheDate('short_date_year_long_time_simple') }}
                  <inline-svg
                    :src="require('@/assets/img/icons/icon-watch.svg')"
                    v-if="transactionIsPending"
                    class="pending-icon"
                  />
                </span>

              </div>

              <div class="transaction-amount">
                {{ transactionAmountIntegers
            }}<span class="cents">,{{ transactionAmountDecimals }}</span>
              </div>
              <div
                v-if="showAmountCurrency"
                class="transaction-currency"
              >
                <img
                  alt="info"
                  class="icon-info"
                  :src="require('@/assets/img/icons/icon-info-white.svg')"
                >
                <span>{{$t('transactions_edit_original_amount')}} {{amountCurrencyValue}}</span>
              </div>
              <div
                class="merchant-name black ellipsis"
                v-tooltip="transactionMerchant"
              >
                {{ transactionMerchant }}
              </div>
            </div>
          </div>
          <div class="transaction-user">
            <user-name-badge
              :userName="transactionUserNameAndLastName"
              :userAvatarId="transactionUserProfilePictureId"
              overrideMargins
              thumbSizeClass="Thumb--35"
            ></user-name-badge>
            <span class="transaction-user-text ml-2">
              {{ transactionUserNameAndLastName }}
            </span>
          </div>
        </div>
        <warning-container
          :transaction="transaction"
          extraClass="transaction-detail-warning"
          @showIgnoreWarning="showIgnoreWarning"
          @showTransactionModal="showTransactionModal"
        />
        <div
          class="transaction-detail-container transaction-detail-container-log"
          :class="{'transaction-detail-container--log-with-notes' : hasReviewNotes,
          'transaction-detail-container--log-expanded' : showTimeline}"
        >
          <p
            class="transaction-detail-header clickable"
            @click="toggleTimeline"
          >{{$t('transactions_detail_review_log_header')}}
            <inline-svg
              class="history-arrow"
              :class="{'history-arrow-rotate' : showTimeline}"
              :src="require('@/assets/img/icons/chevron-down-black.svg')"
              alt="arrow-down"
            />
          </p>
          <transaction-review-status-log
            :transaction="transaction"
            place="detail"
            :showTimeLine="showTimeline"
            @toggleTimeline="setTimeline"
            v-if="transactionId"
          />
        </div>
        <div class="row">
          <div
            v-if="transaction.notes"
            class="col-12"
          >
            <div class="transaction-detail-container">
              <p class="transaction-detail-header">{{$t('transactions_edit_transaction_notes_field')}}</p>
              <p class="transaction-detail-notes">{{ transaction.notes }}</p>
            </div>
          </div>
          <div class="col-12 transaction-detail-edit">
            <span
              class="transaction-detail-edit--action"
              @click="showEditTransactionModal"
            >{{ $t('ACTION_EDIT') }}</span>
            <receipts-container
              :edit="false"
              :transactionId="transactionId"
              :receipts="receipts"
              :transactionWithoutReceiptNotes="transactionWithoutReceiptNotes"
              :transactionWithoutReceipt="transactionWithoutReceipt"
              @showReceiptModal="emitShowReceiptModal"
            ></receipts-container>
          </div>
          <div class="col-12">
            <div class="transaction-detail-container">
              <p class="transaction-detail-header">{{ $t('diet_data') }}</p>
              <div class="transaction-detail-data">
                <p class="transaction-detail-data--left">{{ $t('transactions_edit_transaction_budget') }}</p>
                <p class="transaction-detail-data--right">{{ budgetName || '-' }}</p>
              </div>
              <div
                v-if="transaction.paymentMethod && transaction.paymentMethod.officePaymentMethod && transaction.paymentMethod.officePaymentMethod.name"
                class="transaction-detail-data"
              >
                <p class="transaction-detail-data--left">{{ $t('transactions_edit_transaction_payment_method') }}</p>
                <p class="transaction-detail-data--right">{{ transaction.paymentMethod.officePaymentMethod.name || '-' }}</p>
              </div>
              <div class="transaction-detail-data">
                <p class="transaction-detail-data--left">{{ $t('expense_mileage_origin') }}</p>
                <p class="transaction-detail-data--right right-title">{{ $t('transactions_edit_transaction_date') }}</p>
              </div>
              <div class="transaction-detail-data">
                <p class="transaction-detail-data--left left-data">{{ origin.placeInfo.name || '-' }}</p>
                <p class="transaction-detail-data--right">{{ origin.date | formatTheDate('short_date_year_long_time_simple') }}</p>
              </div>
              <div class="transaction-detail-data">
                <p class="transaction-detail-data--left">{{ $t('expense_mileage_destination') }}</p>
                <p class="transaction-detail-data--right right-title">{{ $t('transactions_edit_transaction_date') }}</p>
              </div>
              <div
                v-for="destination in destinations"
                :key="destination.id"
                class="transaction-detail-data"
              >
                <p class="transaction-detail-data--left left-data">{{ destination.placeInfo.name }}</p>
                <p class="transaction-detail-data--right">{{ destination.date | formatTheDate('short_date_year_long_time_simple') }}</p>
              </div>
              <div class="transaction-detail-data">
                <p class="transaction-detail-data--left">{{ $t('DIET') }}</p>
                <p class="transaction-detail-data--right right-title">{{ $t('expense_mileage_amount_abbr') }}</p>
                <p class="transaction-detail-data--right right-title">{{ $t('expense_mileage_amount') }}</p>
              </div>
              <div
                v-for="category in categories"
                :key="category.id"
                class="transaction-detail-data"
              >
                <p class="transaction-detail-data--left left-data">{{ category.dietCategory.name }}</p>
                <p class="transaction-detail-data--right">{{ category.count }}</p>
                <p class="transaction-detail-data--right">{{category.value | currency('€', 2, {symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ','})}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div
              class="map--smaller"
              v-if="origin && destinations"
            >
              <google-maps
                v-if="origin && destinations"
                :id="`google-maps-small`"
                :mapClass="'map-content--small'"
                :waypoints="routeWaypoints"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="w-100 h-100 d-flex justify-content-center align-items-center">
          <spinner v-if="isGettingTransaction || !initialized"></spinner>
        </div>
      </div>
    </template>

    <template slot="footer">
      <template v-if="!isGettingTransaction && !transactionIsLocked && !isInExpensesSection">
        <funnel-actions
          v-show="reviewStatus"
          @reviewStatusChanged="emitReviewStatusChanged"
          :reviewStatus.sync="reviewStatus"
          :budgetOwner="isBudgetOwner"
          :expenseOwner="transactionOwner"
          :transactionId.sync="transactionId"
        />
      </template>
      <template v-if="isGettingTransaction">
        <div class="w-100 h-100 d-flex justify-content-center align-items-center">
          <spinner></spinner>
        </div>
      </template>
    </template>
    <template slot="modals">
      <confirm-modal
        v-if="showIgnoreWarningModal"
        :open.sync="showIgnoreWarningModal"
        modalClass="ModalBox--400"
        :title="'transaction_warning_ignore_modal'"
        :message="'transaction_warning_ignore_message'"
        :acceptText="'transaction_warning_ignore'"
        :dismissText="'ACTION_CANCEL'"
        acceptBtnClass="blue"
        dismissBtnClass="danger"
        @accept="ignoreWarning"
        @dismiss="dismissWarning"
      ></confirm-modal>
      <confirm-modal
        v-if="showUploadInProgress"
        :open.sync="showUploadInProgress"
        :modalClass="'ModalBox--400'"
        :title="''"
        :message="''"
        :acceptText="'transaction_upload_in_progress_understood'"
        acceptBtnClass="blue"
        closeButton
        noPadding
        noMargin
        hideDismissButton
        @accept="uploadingAccept"
      >
        <template v-slot:content>
          <div class="transaction-upload-in-progress">
            <img
              :src="require('@/assets/img/upload-in-progress.svg')"
              alt=""
            />
            <p class="transaction-upload-in-progress--title">{{ $t('transaction_upload_in_progress_title') }}</p>
            <p class="transaction-upload-in-progress--description">{{ $t('transaction_upload_in_progress_description') }}</p>
          </div>
        </template>
      </confirm-modal>
    </template>
  </lateral-modal>
</template>

<script>
import { DEFAULT_CURRENCY } from '@/utils/constants'
import { currency } from '@/filters'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import _transactionsTableRowInfo from '../../_mixins/_transactionsTableRowInfo'
import _transactionsCustomFieldsHandler from '../../_mixins/_transactionsCustomFieldsHandler'
import _transactionTaxesHandler from '../../_mixins/_transactionTaxesHandler'
import _transactionAndExpenseCommon from '../../_mixins/_transactionAndExpenseCommon'
import _transactionReceiptHandler from '../../_mixins/_transactionReceiptDragAndDropHandler'
import _transactionStatusHandlerMixin from '../../_mixins/_transactionStatusHandlerMixin'
import _transactionsValidationHandlerMixin from '../../_mixins/_transactionsValidationHandlerMixin'
import ReceiptsContainer from '@/components/Commons/ReceiptsContainer.vue'
import TransactionReviewStatusLog from '../funnel/statusLog/TransactionReviewStatusLog.vue'
import FunnelActions from '../funnel/FunnelActions.vue'
import UserNameBadge from '@/components/Commons/UserNameBadge'
import InlineSvg from 'vue-inline-svg'
import Spinner from '@/components/Commons/Spinner'
import WarningContainer from '../_shared/WarningContainer.vue'
import LateralModal from '@/components/Commons/Modals/LateralModal'
import GoogleMaps from '@/components/Google/GoogleMaps'

const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
const TransactionsDropdown = () => import('../_shared/TransactionsDropdown')
const TransactionDetailStatus = () => import('../_shared/TransactionDetailStatus')

export default {
  name: 'MileageDetailModal',
  mixins: [
    _modalHandlerMixin,
    _transactionsTableRowInfo,
    _transactionsCustomFieldsHandler,
    _transactionTaxesHandler,
    _transactionAndExpenseCommon,
    _transactionReceiptHandler,
    _transactionStatusHandlerMixin,
    _transactionsValidationHandlerMixin
  ],
  components: {
    UserNameBadge,
    TransactionsDropdown,
    Spinner,
    InlineSvg,
    FunnelActions,
    TransactionReviewStatusLog,
    WarningContainer,
    ConfirmModal,
    TransactionDetailStatus,
    ReceiptsContainer,
    LateralModal,
    GoogleMaps
  },
  computed: {
    origin () {
      return this.transaction.expense?.diet?.dietSteps[0]
    },
    destinations () {
      return this.transaction.expense?.diet?.dietSteps.slice(1)
    },
    categories () {
      return this.transaction.expense?.diet?.dietCategoryConfigs
    },
    showAmountCurrency () {
      return this.transaction?.currencyAmount?.originalCurrencyCode !== DEFAULT_CURRENCY && this.transaction?.currencyAmount?.originalCurrencyCode !== ''
    },
    amountCurrencyValue () {
      return currency(this.transaction.currencyAmount.amountOriginalCurrency, this.transaction?.currencyAmount?.originalCurrencyCode)
    },
    office () {
      return this.$store.getters['CompanyStore/currentCompany'] || false
    },
    transactionAmountToDisplay () {
      return this.transaction
        ? this.$options.filters.currency(this.transaction.amount, '€', 2, {
          symbolOnLeft: false,
          thousandsSeparator: '.',
          decimalSeparator: ','
        })
        : 0
    },
    budgetName () {
      return this.transaction?.budget?.name
    },
    transactionAmountIntegers () {
      return this.transaction
        ? `${this.transactionAmountToDisplay}`.split(',')[0]
        : '0'
    },
    transactionAmountDecimals () {
      return this.transaction
        ? `${this.transactionAmountToDisplay}`.split(',')[1]
        : '00 €'
    },
    transactionLockedLabel () {
      return this.$t('transaction_edit_locked_transaction_label', {
        date: this.$moment.utc(this.transaction.lockedAt).format('DD/MM/YY HH:mm')
      })
    },
    currentUser () {
      return this.$store.getters['UsersStore/userLogged']
    },
    isSuperBook () {
      return this.$store.getters['LoginStore/isSuperBookKeeper']
    },
    // Susceptible de moverse a mixin
    reviewStatus () {
      return this.transaction && this.transaction.reviewStatus ? this.transaction.reviewStatus.code : false
    },
    isBudgetOwner () {
      return this.transaction && this.transaction.budget ? this.transaction.budget.imOwner : false
    },
    transactionOwner () {
      return this.transaction && this.transaction.card ? this.transaction.card.user : false
    },
    hasReviewNotes () {
      return this.transaction?.transactionReviewStatusLogs.findIndex(el => el.notes) > -1 || false
    }
  },
  data () {
    return {
      isGettingTransaction: false,
      showIgnoreWarningModal: false,
      showTimeline: false,
      routeWaypoints: [],
      expenseType: 'DIET'
    }
  },
  methods: {
    toggleTimeline () {
      this.showTimeline = !this.showTimeline
    },
    setTimeline (event) {
      this.showTimeline = event
    },
    transactionCategory (category) {
      category = category || {}
      let className = ''

      if (category?.headerImageUrl) {
        className = `url(${category.headerImageUrl})`
      } else {
        switch (category.code) {
          case '001':
            className = 'food-and-drinks'
            break
          case '002':
            className = 'office'
            break
          case '003':
            className = 'travel-and-transport'
            break
          case '004':
            className = 'others'
            break
          case '005':
            className = 'computing'
            break
          case '007':
            className = 'comunications'
            break
          case '008':
            className = 'software-and-hardware'
            break
          case '009':
            className = 'training-or-entertainment'
            break
          case '010':
            className = 'marketing-and-advertising'
            break
          default:
            className = 'default'
            break
        }
      }

      return className
    },
    showEditTransactionModal () {
      this.closeModal()
      this.$emit('showEditTransactionModal')
    },
    emitReviewStatusChanged () {
      this.$emit('reviewStatusChanged')
    },
    generateMapWaypoints () {
      const steps = this.transaction.expense.diet.dietSteps.map(el => {
        if (el.placeInfo.lat && el.placeInfo.lng) {
          const waypoint = {}
          waypoint.lat = el.placeInfo.lat
          waypoint.lng = el.placeInfo.lng
          waypoint.stepOrder = el.stepOrder

          return waypoint
        }
      })
      const validSteps = steps.filter(el => el)
      return validSteps.sort((a, b) => a.stepOrder - b.stepOrder)
    }
  },
  watch: {
    transactionId: async function (newV, oldV) {
      await this.fetchTransaction()
    },
    transactionBudgetId: function (newV, oldV) {
      this.budget = { id: this.transactionBudgetId }
      this.notes = this.transaction.notes
    },
    'transaction.isCompleted': function (newV, oldV) {
      if (newV) {
        this.$emit('transactionCompleted')
      }
      if (!newV && oldV) {
        this.$emit('transactionIncompleted')
      }
    }
  },
  async created () {
    this.$store.dispatch('TransactionsStore/clearCurrentTransaction')
    // Is mandatory to get the transaction before doing the user budgets call
    await this.fetchTransaction()
    const promises = []

    if (this.vatTypes.length === 0) {
      promises.push(this.$store.dispatch('TransactionsStore/fetchVatTypes'))
    }
    if (this.isSuperBook) {
      const filters = {
        'transaction.id': this.transactionId
      }
      promises.push(this.$store.dispatch('CategoriesStore/setCategoriesFilters', filters))
    }
    Promise.allSettled(promises).then(() => {
      this.routeWaypoints = this.generateMapWaypoints()
    })
  },

  beforeRouteUpdate (to, from, next) {
    this.closeModal()
    next()
  },
  destroyed () {
    this.$store.dispatch('TransactionsStore/clearCurrentTransaction')
  }
}
</script>
<style scoped lang="scss" src="@/assets/styles/transactions/transactions-edit.scss">
</style>
<style lang="scss" scoped>
.transaction-detail-edit {
  position: relative;
  margin-top: 28px;
  &--action {
    position: absolute;
    right: 16px;
    top: -12px;
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
    color: var(--text-link);
    cursor: pointer;
  }
}
.transaction-detail-container {
  margin-top: 16px;
  background: var(--fill-background);
  border: 1px solid var(--fill-divider);
  border-radius: 4px;
  padding: 16px;

  &--log-with-notes {
    border: 1px solid var(--semantic-alert-main);
  }
  .transaction-detail-header {
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    color: var(--text-heading);
  }
  .transaction-detail-notes,
  .transaction-detail-empty-receipt {
    margin: 0;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: var(--text-body);
  }
  .transaction-detail-data {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 4px;
    &--left,
    .left-color,
    &--right,
    .right-color {
      flex: 1;
      margin: 0;
      font-weight: 500;
      font-size: 15px;
      line-height: 24px;
      color: var(--text-heading);
    }
    &--right,
    .right-color {
      font-weight: 400;
      text-align: right;
      color: var(--text-body);
    }
    .left-data {
      font-weight: 400;
      color: var(--text-body);
    }
    .right-title {
      font-weight: 500;
      color: var(--text-heading);
    }
  }
}
</style>
<style>
.ModalBox--footer {
  padding: 1rem 0.9rem !important;
}
</style>

<style lang="scss" scoped>
.history-arrow {
  max-height: 16px;
  transition: all 0.2s ease;
  position: relative;
  right: 5px;

  &-rotate {
    max-height: 16px;
    transform: rotateZ(-180deg);
  }
}
.map--smaller {
  margin-top: 16px;
  display: block;
  height: 364px;
}
</style>
